import React from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import "./skills.css";

function Skills() {
  const ref = useScrollReveal();

  const skills = [
    {
      category: "Operating Systems",
      items: ["macOS", "Linux", "Windows", "Kali Linux", "Ubuntu"],
    },
    {
      category: "Languages & Scripting",
      items: ["Python", "Bash", "Scapy", "C++", "JavaScript", "SQL", "Typescript"],
    },
    {
      category: "Networking & Security",
      items: ["Cisco", "Wireshark", "Metasploit", "Nmap", "John the Ripper", "recon-ng", "Docker", "Ubiquiti"],
    },
  ];

  return (
    <section ref={ref} id="skills" className="skills reveal">
      <div className="section-inner">
        <div className="section-header reveal-child" style={{ '--i': 0 }}>
          <span className="section-number font-mono">01</span>
          <h2 className="section-title">Skills</h2>
        </div>
        <div className="skills-grid">
          {skills.map((group, i) => (
            <div className="skill-card reveal-child" key={i} style={{ '--i': i + 1 }}>
              <h3 className="skill-card-title font-mono">{group.category}</h3>
              <ul className="skill-list">
                {group.items.map((item, j) => (
                  <li key={j} className="skill-item">{item}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Skills;
